// This is to wipe out the original carbon icons list which CA does not use (it uses ba-graphics for all icons).
// It eliminates carbon-icon-list from ca-ui-common bundle which will save roughly 100k in term of file size.

export default [];